import preloader from "../utils/preloader";
import {getSectionCookie} from "../sections/section-cookie";

export default function initializeHomeBrands() {
    document.querySelectorAll('.block-home-brands').forEach(function (block) {
        new HomeBrandsClass(block);
    });
}

class HomeBrandsClass {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        this.preloaderDOM = this.block.querySelector('.preloader');
        this.ajaxContentDOM = this.block.querySelector('.ajax-content');
        this.baseHref = window.location;
        this.loadBrands();
    }

    loadBrands() {
        preloader(true, this.preloaderDOM);
        this.ajaxContentDOM.innerHTML = '';
        let xhr = new XMLHttpRequest();
        let section = getSectionCookie();
        let baselink = this.ajaxContentDOM.dataset.baselink;
        xhr.open('GET', this.baseHref.origin + '/wp-json/pa/v1/brands/home-random-brands/?section='+section+'&baselink='+baselink );
        xhr.send();
        xhr.onload = function () {
            if (xhr.status !== 200) {
                console.error(`Error ${xhr.status}: ${xhr.statusText}`); // e.g. 404: Not Found

            } else {
                try {
                    this.ajaxContentDOM.innerHTML = JSON.parse(xhr.responseText);
                } catch (e) {
                    console.error(xhr.responseText);
                }
                setTimeout(function () {
                    preloader(false,  this.preloaderDOM);
                    this.ajaxContentDOM.classList.remove('loading');
                    this.ajaxContentDOM.classList.add('ready');
                }.bind(this), 25);
            }
        }.bind(this);
        xhr.onerror = function () {
            console.log('Request failed');
        }
    }
}
